// src/components/common/ActionButton.tsx
import { type ReactNode } from 'react';
import { Plus } from 'lucide-react';

interface ActionButtonProps {
  onClick: () => void;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function ActionButton({
  onClick,
  icon = <Plus className="w-4 h-4" />,
  children,
  className = 'bg-cyan-600 hover:bg-cyan-500 shadow-cyan-900/20',
}: ActionButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 text-white px-5 py-2.5 rounded-xl transition-all shadow-lg ${className}`}
    >
      {icon}
      {children}
    </button>
  );
}